





























import { Vue, Component, Prop } from 'vue-property-decorator'
import { RunStatusAll } from '@/components/index'
@Component({
  components: {
    RunStatusAll
  }
})
export default class TitleInfo extends Vue {
  /**
   * detailObj
   * code
   */
  @Prop() detailObj!: any
}
